import { useCallback } from 'react';
import { useCampaignEditorContext } from 'sections/onsite-campaigns/pages/CampaignEditor/contexts/CampaignEditorContext';

export const useSetVariantWeight = () => {
  const { dispatch } = useCampaignEditorContext();
  return useCallback(
    (payload: { id: string; variantWeights: { messageId: string; weight: number }[] }) => {
      dispatch({
        type: 'UPDATE_VARIANT_WEIGHT',
        payload,
      });
    },
    [dispatch],
  );
};
